import React from "react";
import SuperAdminPayrollSettings from "../admin/PayrollSettingsPage";

const PayrollSettingsPage = () => {
    return <SuperAdminPayrollSettings />;
};

export default PayrollSettingsPage;
